export default __webpack_public_path__ + "static/media/visioncam.d15ebc4f.jpg";